import router from './router';
import Vue from 'vue';


// AJAX请求默认参数
$.ajaxSetup({
	type: "POST",
	dataType: "json",
	timeout: 30000,
    beforeSend : function(request) {
        // request.setRequestHeader("Content-Type", "application/json; charset=utf-8");
        // request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        request.setRequestHeader("Accept", "*/*");
        request.setRequestHeader("appVersion", "1.0");
        request.setRequestHeader("deviceVersion", getOs() + ',' + validB());
        request.setRequestHeader("deviceModel", navigator.platform);
        request.setRequestHeader("device",'h5');
        // 针对积分抽奖、每日抽奖修改headers头
        if(router.app._route.name=='integralDraw'||router.app._route.name=='everyDayDraws'){
          if(router.app._route.query.data){
            let routerData = JSON.parse(decodeURIComponent(router.app._route.query.data))
            request.setRequestHeader("device", routerData.device);
            request.setRequestHeader("channel", routerData.channel);
            request.setRequestHeader("deviceVersion", routerData.deviceVersion);
            request.setRequestHeader("deviceModel", routerData.deviceModel);
            request.setRequestHeader("appVersion", routerData.appVersion);
          }else{
            if(router.app._route.query.token&&router.app._route.query.users_id){
              request.setRequestHeader("device", router.app._route.query.device);
              request.setRequestHeader("channel", router.app._route.query.channel);
              request.setRequestHeader("deviceVersion", router.app._route.query.deviceVersion);
              request.setRequestHeader("deviceModel", router.app._route.query.deviceModel);
              request.setRequestHeader("appVersion", router.app._route.query.appVersion);
            }else{
              let routeData = Vue.prototype.$getParams(window.location.href);
              request.setRequestHeader("device", routeData.device);
              request.setRequestHeader("channel", routeData.channel);
              request.setRequestHeader("deviceVersion", routeData.deviceVersion);
              request.setRequestHeader("deviceModel", routeData.deviceModel);
              request.setRequestHeader("appVersion", routeData.appVersion);
            }


          }
        }
        if (Vue.prototype.getBiguoUserInfo() && Vue.prototype.getBiguoUserInfo().token) {
          request.setRequestHeader("token",Vue.prototype.getBiguoUserInfo().token)
        }
    }
});


//提取操作系统和浏览器
function validB() {
  var u_agent = navigator.userAgent;
  var B_name = "Failed to identify the browser";
  if (u_agent.indexOf("Firefox") > -1) {
    B_name = "Firefox";
  } else if (u_agent.indexOf("Chrome") > -1) {
    B_name = "Chrome";
  } else if (u_agent.indexOf("MSIE") > -1 && u_agent.indexOf("Trident") > -1) {
    B_name = "IE(8-10)";
  }
  return B_name;
}

//获取操作系统
function getOs() {
  var sUserAgent = navigator.userAgent;
  var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "MacOS";

  var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
  if (isUnix) return "Unix";

  var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
  if (isLinux) return "Linux";

  if (isWin) {
    var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) return "Windows2000";

    var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) return "WindowsXP";

    var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) return "Windows2003";

    var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) return "Windows Vista";

    var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) return "Windows7";

    var isWin10 = sUserAgent.indexOf("Windows NT 10.0") > -1 || sUserAgent.indexOf("Windows 10") > -1;
    if (isWin10) return "Windows10";
  }
}


function request(type,url,data={},callback,errCallback){
    $.ajax({
        type:type,
        url:url,
        dataType: 'json',
        // data:type=='post'?JSON.stringify(data):data,
        data:data,
        success (result, status, xhr){
          console.log(result, status, xhr)

            if (result.result_code === -1 || result.code === -1) {
              vant.Toast('登录信息失效，需要重新登录');
              Vue.prototype.removeBiguoUserInfo()
              // location.reload(); // 为了重新实例化vue-router对象 避免bug
            } else if (result.result_code === 0 || result.code === 0) {
              vant.Toast(result.result_info || result.info || '数据错误');
            }
            typeof(callback) == "function" && callback(result, status, xhr);
        },
        error (xhr, status, error) {
            // vant.Toast(error.message);
            vant.Toast('请求错误');
            typeof(errCallback) == "function" && errCallback(xhr, status, error);
        }
    })
}


export default request


// WEBPACK FOOTER //
// ./src/http.js